interface ITransferHttpProviderDefaults extends ng.IHttpProviderDefaults {
  useXDomain: boolean;
}

interface ITransferHttpProvider extends ng.IHttpProvider {
  defaults: ITransferHttpProviderDefaults;
}

angular
  .module('capability-ng-global')
  .config(function($httpProvider: ITransferHttpProvider, NetworkUrlConfigurationProvider: any) {
    $httpProvider.defaults.useXDomain = true;

    NetworkUrlConfigurationProvider.activate({
      prependUrl: '/api',
      logActivity: false,
      includeBaseUrl: false,
      trailingSlash: true,
      forceRefresh: false,
      defaultHeaders: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      defaultHTTPFields: {
        timeout: 20000,
        xsrfHeaderName: 'X-CSRFToken',
        xsrfCookieName: 'csrftoken',
        withCredentials: false,
        cache: false
      }
    });
  });



// WEBPACK FOOTER //
// ./app/lib/global/configuration/network_url_formatting.ts